module.exports = __webpack_public_path__ + "static/media/ky.ad957064.svg";